const Languages = Object.freeze({
  greek: 'el',
  english: 'en',
});

export default Languages;
